/* CBL – produktside: "Fuldfør dit sæt" (størrelsesvælger + læg begge i kurv), oprydning
   (Trustpilot-/størrelsesguide-accordion, OBS-boks) og semantiske H2/H3 i beskrivelsen. */
(function () {
  function swapTag(el, tag, extra) {
    var n = document.createElement(tag);
    n.setAttribute('style', (el.getAttribute('style') || '').replace(/'Cormorant Garamond'/g, "'Playfair Display'") + ';' + (extra || ''));
    while (el.firstChild) n.appendChild(el.firstChild);
    el.parentNode.replaceChild(n, el);
    return n;
  }
  function semanticHeadings() {
    var pd = document.querySelector('.cbl-pd');
    if (!pd || pd.getAttribute('data-cbl-sem')) return;
    pd.setAttribute('data-cbl-sem', '1');
    var first = true;
    Array.prototype.slice.call(pd.querySelectorAll('div[style]')).forEach(function (el) {
      if (!el.parentNode) return;
      var s = el.getAttribute('style') || '';
      var txt = (el.textContent || '').trim();
      if (!txt || txt.length > 80) return;
      if (/letter-spacing:\s*0\.22em/.test(s) && /uppercase/.test(s)) {
        if (first) { first = false; return; }
        swapTag(el, 'h2', 'font-weight:normal;margin-top:0');
      } else if (/font-size:\s*1\.1rem/.test(s) && /serif/.test(s)) {
        swapTag(el, 'h3', 'font-weight:normal;margin-top:0');
      }
    });
  }
  function tidyProductPage() {
    document.querySelectorAll('.product-detail-accordion').forEach(function (acc) {
      var t = acc.querySelector('.with-icon__beside');
      if (!t) return;
      var txt = t.textContent || '';
      if (/trustpilot/i.test(txt) || /størrelsesguide/i.test(txt)) acc.remove();
    });
    document.querySelectorAll('.rte div, .rte p').forEach(function (el) {
      var s = (el.textContent || '').trim();
      if (/^OBS:/i.test(s) && /størrelse/i.test(s) && s.length < 200) el.remove();
    });
    semanticHeadings();
  }
  function openDrawerIfFlagged() {
    if (location.search.indexOf('cbl_cart=1') === -1) return;
    try { history.replaceState(null, '', location.pathname + location.hash); } catch (e) {}
    function tryOpen() {
      var link = document.querySelector('a.cart-link');
      var drawer = document.querySelector('.cart-drawer-modal');
      if (!link || !drawer) return;
      link.click();
    }
    function schedule() { setTimeout(tryOpen, 700); }
    if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule);
  }
  function init() {
    tidyProductPage();
    var box = document.querySelector('.cbl-match');
    var form = document.querySelector('form.product-purchase-form');
    if (!box || !form || box.getAttribute('data-cbl-bundle')) return;
    box.setAttribute('data-cbl-bundle', '1');
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var lbl = box.children[0];
    if (lbl && /kompl[eé]t sættet/i.test(lbl.textContent)) lbl.textContent = lbl.textContent.replace(/kompl[eé]t sættet/i, 'Fuldfør dit sæt');
    var cache = {};
    function getJSON(handle) {
      if (!cache[handle]) cache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });
      return cache[handle];
    }
    function currentVariantId() { var el = form.querySelector('select[name="id"], input[name="id"]'); return el ? parseInt(el.value, 10) : null; }
    function currentSize(cur) {
      var id = currentVariantId();
      var v = cur.variants.filter(function (x) { return x.id === id; })[0] || cur.variants[0];
      return v ? v.option1 : null;
    }
    function addItems(items) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'kunne ikke tilføje'); return j; }); });
    }
    var note = document.createElement('div');
    note.className = 'cbl-bundle__note';
    note.textContent = 'Spar 10 % – rabatten trækkes automatisk, når du har 2 dele fra samme serie i kurven.';
    box.insertBefore(note, box.children[1] || null);

    var cards = [];
    box.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var mm = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
      if (!mm) return;
      var handle = mm[1];
      var sizesEl = document.createElement('span');
      sizesEl.className = 'cbl-bundle__sizes';
      var btn = document.createElement('span');
      btn.className = 'cbl-bundle__btn';
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      btn.textContent = '+ Læg i kurv sammen';
      a.appendChild(sizesEl);
      a.appendChild(btn);
      var card = { a: a, handle: handle, sizesEl: sizesEl, btn: btn, selected: null, userPicked: false };
      cards.push(card);

      getJSON(handle).then(function (p) {
        var seen = {};
        p.variants.forEach(function (v) {
          if (seen[v.option1]) return; seen[v.option1] = true;
          var s = document.createElement('span');
          s.className = 'cbl-bundle__size' + (v.available ? '' : ' is-soldout');
          s.textContent = v.option1;
          s.setAttribute('data-size', v.option1);
          s.setAttribute('role', 'button');
          s.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            if (!v.available) return;
            card.userPicked = true;
            selectSize(card, v.option1);
          });
          sizesEl.appendChild(s);
        });
        getJSON(m[1]).then(function (cur) { selectSize(card, currentSize(cur), true); });
      }).catch(function () { sizesEl.textContent = ''; });

      function run(e) {
        e.preventDefault(); e.stopPropagation();
        if (btn.classList.contains('is-busy')) return;
        if (!card.selected) { btn.textContent = 'Vælg størrelse'; setTimeout(function () { btn.textContent = '+ Læg i kurv sammen'; }, 2000); return; }
        btn.classList.add('is-busy'); btn.textContent = 'Tilføjer…';
        var curId = currentVariantId();
        Promise.all([getJSON(m[1]), getJSON(handle), fetch('/cart.js').then(function (r) { return r.json(); })]).then(function (res) {
          var cur = res[0], match = res[1], cart = res[2];
          var curVar = cur.variants.filter(function (v) { return v.id === curId; })[0] || cur.variants[0];
          var mv = match.variants.filter(function (v) { return v.option1 === card.selected && v.available; })[0];
          if (!mv) throw new Error(card.selected + ' er udsolgt');
          var items = [{ id: mv.id, quantity: 1 }];
          var curInCart = cart.items.some(function (it) { return it.variant_id === curVar.id; });
          if (!curInCart && curVar.available) items.unshift({ id: curVar.id, quantity: 1 });
          return addItems(items);
        }).then(function () {
          btn.textContent = '✓ Lagt i kurven';
          location.href = location.pathname + '?cbl_cart=1';
        }).catch(function (err) {
          btn.classList.remove('is-busy'); btn.textContent = 'Fejl: ' + (err && err.message ? err.message : 'prøv igen');
          setTimeout(function () { btn.textContent = '+ Læg i kurv sammen'; }, 4000);
          if (window.console) console.error('cbl-bundle', err);
        });
      }
      btn.addEventListener('click', run);
      btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') run(e); });
    });

    function selectSize(card, size, soft) {
      var el = card.sizesEl.querySelector('[data-size="' + size + '"]');
      if (!el || el.classList.contains('is-soldout')) {
        if (soft) { card.selected = null; card.sizesEl.querySelectorAll('.cbl-bundle__size').forEach(function (x) { x.classList.remove('is-active'); }); }
        return;
      }
      card.selected = size;
      card.sizesEl.querySelectorAll('.cbl-bundle__size').forEach(function (x) { x.classList.toggle('is-active', x === el); });
    }

    form.addEventListener('change', function () {
      getJSON(m[1]).then(function (cur) {
        var size = currentSize(cur);
        cards.forEach(function (card) { if (!card.userPicked) selectSize(card, size, true); });
      });
    });
  }
  function boot() { init(); openDrawerIfFlagged(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', init);
})();
